import { Table } from 'reactstrap'
import AppObjectField from '../AppObjectField/AppObjectField'
import './AppObjectFieldTable.css'

export default function AppObjectFieldTable(props) {
  const { object, parentObjectId, action, formInputs, tab } = props
  console.log('AppObjectFieldTable rendered', props)

  // transform the array of fields into a matrix based on field x, y position
  const fieldMatrix = []

  if (tab.tabFields) {
    // start condition
    let yPos = tab.tabFields[0].yPosition
    let xPos = tab.tabFields[0].xPosition
    let row = []
    let cell = []
    tab.tabFields.forEach((tabField, index) => {
    // if the y position changes, we have a new row
      if (tabField.yPosition !== yPos) {
        row.push(cell)
        fieldMatrix.push(row)
        // reset to start condition
        yPos = tabField.yPosition
        xPos = tabField.xPosition
        row = []
        cell = []
      }
      // if the x position changes we have a new column
      if (tabField.xPosition !== xPos) {
        row.push(cell)
        cell = []
        xPos = tabField.xPosition
      }
      cell.push(tabField)

      // push final row (special case)
      if (index === tab.tabFields.length - 1) {
        row.push(cell)
        fieldMatrix.push(row)
        row = []
      }
    })
  }
  // create an HTML table from the matrix of fields
  const tableRows = []
  fieldMatrix.forEach((row, rowIndex) => {
    let tableCells = []
    row.forEach((cell, cellIndex) => {
      let fields = []
      let colSpan = ''
      cell.forEach((tabField) => {
        fields.push(<AppObjectField key={tabField.id} object={object} parentObjectId={parentObjectId} field={tabField.field} action={action} formInputs={formInputs} showFieldLabel={tabField.showLabel} />)
        if (tabField.colSpan) {
          colSpan = tabField.colSpan
        }
      })
      tableCells.push(
        <td key={cellIndex} colSpan={colSpan}>
          {fields}
        </td>
      )
    })
    let tableRow = <tr key={rowIndex}>{tableCells}</tr>
    tableRows.push(tableRow)
  })

  return (
    <Table className="app-object-field-table" data-cy='app-object-field-table' bordered size="sm">
      <tbody>
        {tableRows}
      </tbody>
    </Table>
  )
}
